<template>
	<IconBase icon-name="preview">
		<path d="m 4,12 c 0,0 1.6,-6 8,-6 C 18.4,6 20,12 20,12" class="blueStroke" />
		<circle cx="12" cy="12" r="3" class="blueStroke" />
	</IconBase>
</template>

<script>
import IconBase from './IconBase';
export default {
	components: {
		IconBase
	}
};
</script>
